// 在这里定义全局变量
const state = {
    // 文章详情
    article: {},
    // 文章列表
    articles: [],
    pageTitle: '风铃笔记',
    pageDescription: '风铃笔记',
    metaKeywords: ''
}

//这里是set方法，比如对该数据的修改、增加、删除等等。
//组件调用this.$store.commit('Set_Article_List', list) 将list赋值给这里的state中对应的变量
const mutations = {
    SET_ARTICLE(state, article) {
        state.article = article
    },
    SET_ARTICLES(state, articles) {
        state.articles = articles
    },
    SET_META_TITLE(state, pageTitle) {
        state.pageTitle = pageTitle
    },
    SET_META_DESCRIPTION(state, pageDescription) {
        state.pageDescription = pageDescription
    },
    SET_META_KEYWORDS(state, metaKeywords) {
        state.metaKeywords = metaKeywords
    }
}

//异步处理
//组件中使用this.$store.dispatch('[namespace/]setQueryParams',list)  []中为可选参数，当配置了使用命名空间后就需要指定一个命名空间
const actions = {
    setArticle(context, article) {
        context.commit('SET_ARTICLE', article)
    },
    setArticles(context, list) {
        context.commit('SET_ARTICLES', list)
    },
    // 使用结构语法从 context 对象中取到 commit。 context拥有和store实例具有相同方法和属性，如state、mutation、commit、getters等
    setMetaTitle({ commit }, title) {
        commit('SET_META_TITLE', title)
    },
    setMetaDescription({ commit }, description) {
        commit('SET_META_DESCRIPTION', description)
    },
    setMetaKeywords({ commit }, keywords) {
        commit('SET_META_KEYWORDS', keywords)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}